import { h } from "preact";
import omit from "lodash/omit";

import { classNames } from "../helpers";

let cid = 0;

export default function RadioButton({
  children,
  description,
  onChange,
  ...props
}) {
  const inputProps = omit(props, "class");
  const id = ++cid;

  return (
    <label
      class={classNames(
        "radio-button",
        props.class,
        props.boxed && "waves-effect waves-light",
        props.boxed && "radio-button--boxed"
      )}
      for={inputProps.id}
      role="radio"
      aria-labelledby={`label-${id}`}
      tabindex="0"
    >
      <input type="radio" {...inputProps} onchange={onChange} />
      <span class="radio-button__label">
        {children}
        <span id={`label-${id}`} class="radio-button__desc">
          {description}
        </span>
      </span>
    </label>
  );
}
